<template>
  <v-container fluid class="px-0 pt-0">
    <Loading v-if="isLoading" />
    <v-row class="px-8 py-4 topBar">
      <v-col cols="3" class="pr-4 pl-3">
        <v-btn depressed color="primary" class="btn-add px-0" @click="add">
          <v-icon v-text="'$user_medical'"></v-icon>
          <span>Ajouter une fiche client</span>
        </v-btn>
      </v-col>

      <v-spacer></v-spacer>

      <v-col cols="4" class="text-right">
        <div class="d-flex align-center justify-end">
          <span class="mr-4">Recherche par :</span>
          <v-select
            v-model="searchBy"
            :items="listSearch"
            hide-details
            outlined
            max-width="100"
            style="max-width: 100px"
          ></v-select>
        </div>
      </v-col>

      <v-col cols="2">
        <v-text-field
          hide-details
          outlined
          dense
          v-model="searchText"
          @keyup.enter="() => search()"
        >
          <template v-slot:append>
            <v-btn depressed color="primary" class="topBar-search ma-0" @click="search">
              <v-icon v-text="'$search'"></v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-simple-table
      class="table-full table-layout-fixed table-fixed-height table-hover-none table-resize"
      :fixed-header="true"
      style="white-space:pre-line;word-break: break-all;"
    >
      <thead>
        <tr>
          <th rowspan="2" style="min-width: 40px!important;">ID</th>
          <th rowspan="2">Date</th>
          <th rowspan="2" style="min-width: 230px;width: 230px;border-left: none" class="border-col">Client</th>
          <th rowspan="2" class="w-180">Identite facturable</th>

          <th rowspan="2" class="w-200">Adresse</th>
          <th rowspan="2" class="w-200">CP</th>
          <th rowspan="2" class="w-200">Ville</th>
          <th rowspan="2" class="w-200">Pays</th>

          <th colspan="4" class="border-col">Personne en charge</th>
          <th rowspan="2"></th>
        </tr>
        <tr>
          <th class="w-180">Nom & Prénom</th>
          <th class="w-220">Email</th>
          <th class="w-120">{{$t('Telephone fix')}}</th>
          <th class="w-120">Mobile</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="item in items">
          <td>{{ item.id }}</td>
          <td>{{ item.createdAt | moment('DD/MM/YYYY')}}</td>
          <td>{{ item.name }}</td>
          <td colspan="5" class="pa-0">
            <v-simple-table class="table-full table-client-sub table-layout-fixed">
              <tbody>
                <tr v-for="location in item.clientLocations">
                  <td class="w-180">{{ location.identity }}</td>
                  <td class="w-200">{{ location.address }}</td>
                  <td class="w-200">{{ location.codePostal }}</td>
                  <td class="w-200 text-uppercase">{{ location.city }}</td>
                  <td class="w-200">{{ location.countryName }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </td>
          <td colspan="4" class="pa-0">
            <v-simple-table class="table-full table-client-sub table-layout-fixed">
              <tbody>
                <tr v-for="contact in item.clientContacts">
                  <td class="w-180">{{ contact.name }}</td>
                  <td class="w-220">{{ contact.email }}</td>
                  <td class="w-120">{{ contact.telephone }}</td>
                  <td class="w-120">{{ contact.mobile }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </td>
          <td style="text-align: start;">
            <v-btn icon medium depressed class="noneRipple" @click="edit(item.id)" title="Éditer">
              <v-icon v-text="'$edit'" color="#47266F"></v-icon>
            </v-btn>

            <v-btn
              icon
              medium
              depressed
              class="noneRipple"
              v-show="item.canRemove == true"
              @click="deleteClient(item.id)"
              title="Supprimer"
            >
              <v-icon v-text="'$trash'" color="#47266F"></v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <div class="mt-4 mb-1 mx-4" v-if="totalItems > 0">
      <div class="d-flex align-center">
        <span class="mr-4">Affichage</span>
        <v-select
          v-model="limit"
          :items="itemPerPageList"
          hide-details
          dense
          outlined
          style="max-width: 90px"
        ></v-select>
        <span class="ml-4 mr-2">sur {{ totalItems }} items par page</span>
        <v-pagination class="justify-start" v-model="page" :length="totalPage"></v-pagination>
      </div>
    </div>

    <AddClientForm
      v-model="dialogAddClient"
      v-on:update:item-added="onClientAdded"
      :id="editId"
      :addClient="isAddNew"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import ClientService from "../../services/client.service";
import AddClientForm from "@/components/forms/AddClientForm";
import Loading from "../../components/Loading.vue";

export default {
  name: "Clients",
  data: () => ({
    dialogAddClient: false,
    editId: 0,
    isLoading: false,
    page: 1,
    totalPage: 1,
    items: [],
    limit: 50,
    totalItems: 0,
    searchText: "",
    searchBy: "id",
    listSearch: [],
    isAddNew: false
  }),
  components: {
    AddClientForm,
    Loading
  },
  computed: {
    ...mapState({
      itemPerPageList: state => state.pagination.itemPerPageList,
      itemPerPage: state => state.pagination.itemPerPage
    })
  },
  created() {
    this.listSearch = [
      {
        text: "ID",
        value: "id"
      },
      {
        text: "Client",
        value: "name"
      },
      {
        text: "Identite facturable",
        value: "identity"
      },
      {
        text: "Nom",
        value: "lastName"
      },
      {
        text: "Prénom",
        value: "firstName"
      },
      {
        text: "Email",
        value: "email"
      },
      {
        text: this.$t("Telephone fix"),
        value: "telephoneFix"
      },
      {
        text: "Mobile",
        value: "mobile"
      }
    ];

    this.fetch();
  },
  methods: {
    async fetch(cb = null) {
      this.isLoading = true;
      try {
        const response = await ClientService.getPagedResult({
          page: this.page,
          limit: this.limit,
          searchText: this.searchText,
          searchBy: this.searchBy
        });
        console.log(response);
        this.items = response.data.data;
        this.totalItems = response.data.total;
        this.totalPage = response.data.totalPage;
        if (typeof cb === "function") {
          cb();
        }
      } catch (e) {
        this.$notification.error(e.response.data.error.message);
      }
      this.isLoading = false;
    },
    search() {
      this.fetch();
    },
    onClientAdded(id) {
      this.fetch();
    },
    edit(id) {
      this.editId = id;
      this.dialogAddClient = true;
    },
    async deleteClient(id) {
      if (!(await this.confirm("Confirmez-vous cette action ?"))) {
        return;
      }

      const response = await ClientService.delete(id);

      if (response.data.success == true) {
        this.fetch();
        this.successMessage(this.$t("Client deleted successfully"));
      }
    },
    add() {
      this.editId = 0;
      this.dialogAddClient = true;
      this.isAddNew = true;
    }
  },
  watch: {
    page(item) {
      this.page = item;
      this.fetch();
    },
    limit(item) {
      this.fetch();
    }
  }
};
</script>

